import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.flashCardsStepTwoLevels.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.flashCardsStepTwoLevels.data.currency,
  (currency = {}) => currency
);
const getLevelsData = createSelector(
  (state) => state.flashCardsStepTwoLevels.data.flashCardsStepTwoLevels,
  (levels = []) => levels
);

export default {
  getCurrencyData,
  getHasLoaded,
  getLevelsData,
};
